export enum variants {
  COLORIN = "colorin",
  TERSUAVE = "tersuave",
  PROVEEDORES = "proveedores",
}

export enum variantsName {
  COLORIN = "COMUNIDAD",
  TERSUAVE = "INTERACTUA",
  PROVEEDORES = "PROVEEDORES",
}

export const variantesId = {
  colorin: 9, //: variants.COLORIN,
  tersuave: 2, //: variants.TERSUAVE,
  proveedores: null, //: variants.PROVEEDORES,
};

export const colorinColores = {
  main: "#24275C",
  buttons: "#1F408B",
};

export const tersuaveColores = {
  main: "white",
  buttons: "#1F408B",
};

export const proveedoresColores = {
  main: "#24275C",
  buttons: "#1F408B",
};
